// Serializza una scheda prodotto (dati verificati del sito) in testo leggibile,
// da passare all'assistente virtuale come fonte prioritaria. Nessun dato inventato:
// vengono inclusi solo i campi effettivamente presenti nell'oggetto prodotto.
import { EXECUTION_META } from "@/lib/schiebler";
import { familyLabel } from "@/lib/bendaggi";

const materialToText = (rows) =>
  Array.isArray(rows) ? rows.map((m) => `${m[0]} ${m[1]}`).join(", ") : "";

const bullets = (items) => items.map((i) => `- ${i}`).join("\n");

export const schieblerContext = (product) => {
  const L = [];
  L.push(`SCHEDA PRODOTTO: ${product.name} (marchio SCHIEBLER)`);
  if (product.category) L.push(`Categoria: ${product.category}`);
  if (product.title) L.push(`Sintesi: ${product.title}`);
  if (product.pressure) L.push(`Compressione: ${product.pressure}`);
  if (product.madeToMeasure) L.push("Realizzato su misura: sì");
  if (product.ralCertified) L.push("Qualità: prodotto con marchio di qualità RAL.");
  if (product.description) L.push(`Descrizione: ${product.description}`);
  if (product.features?.length) L.push(`Caratteristiche principali:\n${bullets(product.features)}`);
  if (product.materialNote) L.push(`Nota materiale: ${product.materialNote}`);
  if (product.material?.length) L.push(`Composizione: ${materialToText(product.material)}`);
  if (product.classes?.length) {
    L.push("Classi di compressione disponibili:");
    product.classes.forEach((c) => {
      const parts = [`${c.label}`];
      if (c.material?.length) parts.push(`composizione: ${materialToText(c.material)}`);
      if (c.indications?.length) parts.push(`indicazioni riportate sulla scheda: ${c.indications.join("; ")}`);
      L.push(`- ${parts.join(" — ")}`);
    });
  }
  if (product.variants?.length) L.push(`Varianti: ${product.variants.join("; ")}`);
  const execs = (product.availableExecutions || [])
    .map((id) => EXECUTION_META[id]?.label)
    .filter(Boolean);
  if (execs.length) L.push(`Esecuzioni disponibili: ${execs.join(", ")}`);
  if (product.colors?.length) L.push(`Colori disponibili: ${product.colors.map((c) => c.name).join(", ")}`);
  else if (product.colorsNote) L.push(`Colori: ${product.colorsNote}`);
  if (product.sizes?.length) L.push(`Taglie: ${product.sizes.join(", ")}`);
  if (product.footLength?.length) L.push(`Lunghezza piede: ${product.footLength.join(", ")}`);
  if (product.side?.length) L.push(`Lato: ${product.side.join(", ")}`);
  if (product.packages?.length) L.push(`Confezioni: ${product.packages.join(", ")}`);
  if (!product.classes?.length && product.indications?.length) L.push(`Indicazioni riportate: ${product.indications.join("; ")}`);
  if (product.ingredients?.length) L.push(`Ingredienti: ${product.ingredients.join(", ")}`);
  if (product.safetyBox) L.push(`Avvertenze di sicurezza: ${product.safetyBox}`);
  if (product.device && product.healthNote) L.push(`Nota: ${product.healthNote}`);
  return {
    title: product.name,
    url: `/it/prodotti/schiebler/${product.slug}`,
    text: L.join("\n"),
  };
};

export const bendaggioContext = (product) => {
  const L = [];
  const fam = familyLabel(product.family);
  L.push(`SCHEDA PRODOTTO: ${product.fullName || product.name} (marchio ${product.brand}, categoria ${fam})`);
  if (product.tipologia) L.push(`Tipologia: ${product.tipologia}`);
  if (product.tag && product.tag !== product.tipologia) L.push(`Caratteristica: ${product.tag}`);
  if (product.title) L.push(`Sintesi: ${product.title}`);
  if (product.description) L.push(`Descrizione: ${product.description}`);
  if (product.features?.length) L.push(`Caratteristiche principali:\n${bullets(product.features)}`);
  if (product.characteristics) L.push(`Caratteristiche tecniche: ${product.characteristics}`);
  if (product.material?.length) L.push(`Composizione: ${materialToText(product.material)}`);
  if (product.stretch) L.push(`Allungamento (stirata): ${product.stretch}`);
  if (product.widths?.length) L.push(`Larghezze: ${product.widths.join(", ")}`);
  if (product.lengths?.length) L.push(`Lunghezze: ${product.lengths.join(", ")}`);
  if (product.colors?.length) L.push(`Colore: ${product.colors.map((c) => c.name).join(", ")}`);
  if (product.packages?.length) L.push(`Confezioni: ${product.packages.join(", ")}`);
  if (product.indications?.length) L.push(`Indicazioni riportate: ${product.indications.join("; ")}`);
  if (product.storage) L.push(`Conservazione: ${product.storage}`);
  if (product.warnings) L.push(`Avvertenze: ${product.warnings}`);
  if (product.device && product.healthNote) L.push(`Nota: ${product.healthNote}`);
  return {
    title: product.name,
    url: `/it/prodotti/bendaggi/${product.slug}`,
    text: L.join("\n"),
  };
};
